export default class Landmark {
	constructor({
		name,
		cost,
		description
	}) {
		this.name = name
		this.cost = cost
		this.description = description

		// set to default state
		this.activate()
		this.destroy()
	}

	destroy() {
		if(this.name !== "City Hall")
			this.activated = false
	}

	activate()  {
			this.activated = true
	}
}
